<ion-list *ngIf="attachments?.length > 0; else empty">
	<ng-container *ngFor="let attachment of attachments; index as index">
		<ion-item-group *ngIf="attachment.files.length > 0">
			<ion-item-divider color="medium" mode="md">
				<ion-label>{{ attachment.group }}</ion-label>
			</ion-item-divider>

			<ion-item
				*ngFor="let attachment of attachment.files"
				lines="full"
				color="light"
			>
				{{ attachment.filename }}
				<ion-button
					fill="clear"
					slot="end"
					(click)="downloadFile(attachment)"
				>
					<ion-icon
						slot="icon-only"
						name="download-outline"
					></ion-icon>
				</ion-button>
			</ion-item>
		</ion-item-group>
	</ng-container>
</ion-list>

<ng-template #empty>
	<app-empty-list-item message="No attachments exist"></app-empty-list-item>
</ng-template>

<ion-fab vertical="bottom" horizontal="end" slot="fixed">
	<ion-fab-button (click)="onClickGoToAddAttachment()" color="primary">
		<ion-icon name="add"></ion-icon>
	</ion-fab-button>
</ion-fab>
